import { ReactComponent as Arrow } from '@assets/icons/arrowForward.svg';

import {
  Box,
  Step,
  Stepper as ChakraStepper,
  StepTitle,
  useSteps
} from '@chakra-ui/react';

interface StepperProps {
  steps: string[];
  currentStep: number;
  onChangeStep: (index: number) => void;
  variant?: string;
}

const Stepper = ({
  steps,
  currentStep,
  onChangeStep,
  variant = 'primary'
}: StepperProps) => {
  const { setActiveStep } = useSteps({
    index: currentStep,
    count: steps.length
  });

  const onChangeHandler = (value: number) => () => {
    setActiveStep(value);
    onChangeStep(value);
  };

  return (
    <ChakraStepper
      size='sm'
      orientation='vertical'
      index={currentStep}
      variant={variant}
    >
      {steps.map((step, index) => (
        <Box
          as={Step}
          key={step}
          onClick={onChangeHandler(index)}
          alignItems='center'
          sx={{
            '&[data-status=incomplete]': {
              pointerEvents: 'none',
              opacity: 0.3
            }
          }}
        >
          <StepTitle>{step}</StepTitle>
          {index === currentStep && (
            <Arrow width={14} height={14} fill='white' />
          )}
        </Box>
      ))}
    </ChakraStepper>
  );
};

export default Stepper;
